/* Uniform product card — delegated handlers for image dot sync + Add-to-Cart.
   - Single-variant products: direct AJAX add + open cart drawer.
   - Multi-variant products: open the shared #cvp-sheet picker, let shopper choose, then add.
   Idempotent: safe to load once globally. */
(function () {
  if (window.__upcCardInit) return;
  window.__upcCardInit = true;

  // ============== Helpers ==============
  function getCartItemsSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
      ids.push(c.dataset.sectionId);
    });
    return ids;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') drawer.open();
    else if (typeof drawer.showDialog === 'function') drawer.showDialog();
  }

  function notifyCartUpdated(response, sourceId, variantId, productId) {
    var sections = response && response.sections ? response.sections : {};
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: response,
        sourceId: sourceId,
        data: {
          source: sourceId,
          productId: productId,
          variantId: variantId,
          sections: sections
        }
      }
    }));
    // Belt + suspenders — directly open the drawer too
    setTimeout(openCartDrawer, 50);
  }

  function ajaxAdd(formData, sourceId, variantId, productId) {
    var sectionIds = getCartItemsSectionIds();
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);

    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response && response.status && response.status !== 200) {
          return Promise.reject(new Error(response.message || 'Add failed'));
        }
        notifyCartUpdated(response, sourceId, variantId, productId);
        return response;
      });
  }

  function money(cents) {
    var sym = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'INR') ? '₹' : '₹';
    var amt = (cents / 100);
    return sym + amt.toLocaleString('en-IN', { maximumFractionDigits: amt % 1 === 0 ? 0 : 2 });
  }

  // ============== Image scroller dot sync ==============
  function syncDots(scroller) {
    if (scroller.__upcBound) return;
    scroller.__upcBound = true;
    var media = scroller.closest('[data-upc-media]');
    if (!media) return;
    var dots = media.querySelectorAll('[data-upc-dots] .upc-card__dot');
    if (!dots.length) return;
    var ticking = false;
    function update() {
      var i = Math.round(scroller.scrollLeft / (scroller.clientWidth || 1));
      if (i < 0) i = 0;
      if (i >= dots.length) i = dots.length - 1;
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      ticking = false;
    }
    scroller.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  function initScrollers(root) {
    (root || document).querySelectorAll('[data-upc-scroller]').forEach(syncDots);
  }

  // ============== Variant picker ==============
  var pickerState = { product: null, qty: 1, selectedOptions: [], variant: null };

  function findVariant(product, selected) {
    return product.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === selected[i]; });
    });
  }

  function isOptionValueAvailable(product, optionIndex, value, currentSelection) {
    return product.variants.some(function (v) {
      if (!v.available) return false;
      if (v.options[optionIndex] !== value) return false;
      // any previously fixed options should match
      for (var i = 0; i < optionIndex; i++) {
        if (currentSelection[i] && v.options[i] !== currentSelection[i]) return false;
      }
      return true;
    });
  }

  function renderPickerOptions(sheet, product) {
    var optsRoot = sheet.querySelector('[data-cvp-options]');
    if (!optsRoot) return;
    optsRoot.innerHTML = '';
    product.options.forEach(function (option, oi) {
      var fs = document.createElement('fieldset');
      fs.className = 'cvp__option';
      var legend = document.createElement('legend');
      legend.className = 'cvp__option-label';
      legend.innerHTML = '<span class="cvp__option-name">' + option.name +
        '</span> <span class="cvp__option-selected" data-cvp-option-selected="' + oi + '"></span>';
      fs.appendChild(legend);
      var chipsWrap = document.createElement('div');
      chipsWrap.className = 'cvp__chips';
      chipsWrap.setAttribute('role', 'radiogroup');
      chipsWrap.setAttribute('aria-label', option.name);
      option.values.forEach(function (val) {
        var label = document.createElement('label');
        label.className = 'cvp__chip';
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'opt-' + oi;
        input.value = val;
        input.setAttribute('data-cvp-option-input', '');
        input.setAttribute('data-option-index', oi);
        var span = document.createElement('span');
        span.textContent = val;
        label.appendChild(input);
        label.appendChild(span);
        chipsWrap.appendChild(label);
      });
      fs.appendChild(chipsWrap);
      optsRoot.appendChild(fs);
    });
  }

  function refreshPicker(sheet) {
    var p = pickerState.product;
    if (!p) return;
    var atc = sheet.querySelector('[data-cvp-atc]');
    var atcLabel = sheet.querySelector('[data-cvp-atc-label]');
    var priceEl = sheet.querySelector('[data-cvp-price]');
    var compareEl = sheet.querySelector('[data-cvp-compare]');
    var hiddenIdInput = sheet.querySelector('[data-cvp-variant-id]');

    // Determine current variant from selectedOptions
    var v = findVariant(p, pickerState.selectedOptions);
    pickerState.variant = v;

    // Update chip selected + availability
    sheet.querySelectorAll('.cvp__chip').forEach(function (chip) {
      var input = chip.querySelector('input[data-cvp-option-input]');
      if (!input) return;
      var oi = parseInt(input.getAttribute('data-option-index'), 10);
      var val = input.value;
      var avail = isOptionValueAvailable(p, oi, val, pickerState.selectedOptions);
      chip.classList.toggle('is-unavailable', !avail);
      var sel = pickerState.selectedOptions[oi] === val;
      chip.classList.toggle('is-selected', sel);
      input.checked = sel;
    });

    // Update "selected value" label next to each option name
    p.options.forEach(function (option, oi) {
      var sel = sheet.querySelector('[data-cvp-option-selected="' + oi + '"]');
      if (sel) sel.textContent = pickerState.selectedOptions[oi] ? ' · ' + pickerState.selectedOptions[oi] : '';
    });

    // Update prices + ATC state
    if (v) {
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }
      if (hiddenIdInput) hiddenIdInput.value = v.id;
      if (atc) atc.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? 'Add to cart — ' + money(v.price * pickerState.qty) : 'Sold out';
    } else {
      if (atc) atc.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Select options';
    }
  }

  function openPicker(productData, thumbUrl) {
    var sheet = document.getElementById('cvp-sheet');
    if (!sheet) return;

    pickerState.product = productData;
    pickerState.qty = 1;
    // Default selection: first available variant, else first variant
    var firstAvail = productData.variants.find(function (v) { return v.available; }) || productData.variants[0];
    pickerState.selectedOptions = (firstAvail && firstAvail.options) ? firstAvail.options.slice() : [];

    // Header
    var titleEl = sheet.querySelector('[data-cvp-title]');
    if (titleEl) titleEl.textContent = productData.title || '';
    var thumbEl = sheet.querySelector('[data-cvp-thumb]');
    if (thumbEl) {
      thumbEl.innerHTML = '';
      var imgUrl = thumbUrl || productData.featured_image;
      if (imgUrl) {
        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = productData.title || '';
        img.loading = 'lazy';
        thumbEl.appendChild(img);
      }
    }
    var qtyDisplay = sheet.querySelector('[data-cvp-qty-display]');
    if (qtyDisplay) qtyDisplay.textContent = '1';
    var qtyInput = sheet.querySelector('[data-cvp-quantity]');
    if (qtyInput) qtyInput.value = '1';

    renderPickerOptions(sheet, productData);
    refreshPicker(sheet);

    if (typeof sheet.showModal === 'function') {
      try { sheet.showModal(); } catch (_) { sheet.setAttribute('open', ''); }
    } else {
      sheet.setAttribute('open', '');
    }
  }

  function closePicker() {
    var sheet = document.getElementById('cvp-sheet');
    if (!sheet) return;
    if (typeof sheet.close === 'function') {
      try { sheet.close(); } catch (_) { sheet.removeAttribute('open'); }
    } else {
      sheet.removeAttribute('open');
    }
  }

  // Bind picker interactions ONCE per page
  function bindPicker() {
    var sheet = document.getElementById('cvp-sheet');
    if (!sheet || sheet.__cvpBound) return;
    sheet.__cvpBound = true;

    sheet.querySelector('[data-cvp-close]')?.addEventListener('click', closePicker);
    sheet.addEventListener('click', function (e) { if (e.target === sheet) closePicker(); });

    sheet.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('[data-cvp-option-input]');
      if (!input) return;
      var oi = parseInt(input.getAttribute('data-option-index'), 10);
      pickerState.selectedOptions[oi] = input.value;
      refreshPicker(sheet);
    });

    sheet.querySelectorAll('[data-cvp-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-cvp-qty-step'), 10) || 0;
        pickerState.qty = Math.max(1, pickerState.qty + step);
        var qtyDisplay = sheet.querySelector('[data-cvp-qty-display]');
        if (qtyDisplay) qtyDisplay.textContent = pickerState.qty;
        var qtyInput = sheet.querySelector('[data-cvp-quantity]');
        if (qtyInput) qtyInput.value = pickerState.qty;
        refreshPicker(sheet);
      });
    });

    var form = sheet.querySelector('[data-cvp-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var atc = sheet.querySelector('[data-cvp-atc]');
        var atcLabel = sheet.querySelector('[data-cvp-atc-label]');
        var v = pickerState.variant;
        if (!atc || atc.disabled || !v) return;
        atc.disabled = true;
        var originalLabel = atcLabel ? atcLabel.textContent : '';
        if (atcLabel) atcLabel.textContent = 'Adding…';

        var fd = new FormData();
        fd.append('id', v.id);
        fd.append('quantity', pickerState.qty);

        ajaxAdd(fd, 'card-variant-picker', String(v.id), String(pickerState.product.id))
          .then(function () {
            atc.setAttribute('data-added', 'true');
            if (atcLabel) atcLabel.textContent = '✓ Added to cart';
            setTimeout(function () {
              closePicker();
              atc.removeAttribute('data-added');
              atc.disabled = false;
              if (atcLabel) atcLabel.textContent = originalLabel;
            }, 800);
          })
          .catch(function () {
            if (atcLabel) atcLabel.textContent = 'Try again';
            atc.disabled = false;
          });
      });
    }
  }

  // ============== Card ATC click ==============
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-upc-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var hasOptions = btn.getAttribute('data-has-options') === 'true';
    var card = btn.closest('article, .upc-card, product-card');

    if (hasOptions) {
      // Multi-variant: open picker populated from the inline JSON inside the card
      var dataScript = card ? card.querySelector('script[data-upc-product]') : null;
      if (!dataScript) {
        // Fallback: just navigate to PDP
        var url = btn.getAttribute('data-product-url');
        if (url) window.location.href = url;
        return;
      }
      var productData;
      try { productData = JSON.parse(dataScript.textContent); }
      catch (err) {
        var url2 = btn.getAttribute('data-product-url');
        if (url2) window.location.href = url2;
        return;
      }
      bindPicker();
      // Pull the most recent visible image from the gallery as the thumbnail
      var galleryImg = card ? card.querySelector('.upc-card__media img, .upc-card__slide img') : null;
      openPicker(productData, galleryImg ? galleryImg.currentSrc || galleryImg.src : null);
      return;
    }

    // Single-variant: direct AJAX add
    var id = parseInt(btn.dataset.variantId, 10);
    if (!id) return;
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', 1);

    ajaxAdd(fd, 'uniform-product-card', String(id), '')
      .then(function () {
        btn.setAttribute('data-added', 'true');
        btn.textContent = '✓ Added';
        setTimeout(function () {
          btn.removeAttribute('data-added');
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
  }, { passive: false });

  // ============== Init on DOM ready + after AJAX section renders ==============
  function init() { initScrollers(); bindPicker(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { initScrollers(e.target); bindPicker(); });
  document.addEventListener('section:render', function (e) { initScrollers(e.target); bindPicker(); });

  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('[data-upc-scroller]')) syncDots(n);
          if (n.querySelectorAll) n.querySelectorAll('[data-upc-scroller]').forEach(syncDots);
        });
      });
      bindPicker();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
